// i18n.js — Souvenir configurator translations (EN base + DE / FR / ES)
// On Shopify this file is uploaded as `souvenir-i18n.js`. The active language
// comes from the storefront (request.locale via SOUVENIR_CONFIG.locale); in the
// standalone demo it's switchable from the Tweaks panel or with ?lang=de|fr|es.
// English is always the fallback for any missing key.
(function () {
  var en = {
    eyebrow: "Create your own map",
    yourPlace: "Your Place",
    mapTitle: function (t) { return "City Map Print"; },
    aerialTitle: function (t) { return t + " Aerial Photo Print"; },
    landuseTitle: function (t) { return t + " Land Use Print"; },
    eyebrowAerial: "Create your own aerial photo",
    eyebrowLanduse: "Create your own land-use map",
    tabMap: "Map print",
    tabAerial: "Aerial photo print",
    tabLanduse: "Land use print",
    zoomPre: "Zoomed in very far for the",
    zoomPost: "size — zoom out a touch for the crispest detail on a print this large.",
    dragHint: "Drag to reposition · scroll to zoom",
    recenter: "Recenter",
    magnify: "Magnify",
    currency: "£",
    stepLocation: "Your location",
    stepSize: "Size",
    stepFraming: "Framing",
    stepStyle: "Style",
    stepCaption: "Caption",
    hintCmIn: "cm / in",
    searchPlaceholder: "Find a location…",
    exampleLabel: "example:",
    mapIt: "Map it",
    errNotFound: "We couldn't find that place — try adding a city or country.",
    errUnavailable: "Search is unavailable right now. Check your connection and try again.",
    portrait: "Portrait",
    landscape: "Landscape",
    markers: { pin: "Pin", house: "House", heart: "Heart", dot: "Dot", none: "None" },
    miniMarker: "Marker",
    miniMarkerSize: "Marker size",
    miniMarkerColor: "Marker colour",
    miniLabels: "Labels",
    miniLayout: "Layout", layout1a: "Masthead", layout1b: "Gallery",
    miniBorder: "Border",
    miniDetail: "Map detail", detailRich: "Detailed", detailSimple: "Simple",
    miniAerial: "Aerial photo",
    borderMat: "Wide mat",
    borderLine: "Fine line",
    borderNone: "Borderless",
    borderCircle: "Circle",
    borderHeart: "Heart",
    detailRich: "Detailed",
    detailMinimal: "Minimal",
    fieldTitle: "Title",
    fieldSubtitle: "Subtitle / region",
    fieldCoords: "Coordinates",
    toggleCaption: "Show caption",
    toggleCoords: "Coordinates",
    toggleUpper: "Uppercase title",
    addToBasket: "Add to basket",
    preparing: "Preparing your print…",
    included: "Included",
    framings: {
      paper: "Print on paper",
      metalblk: "Black metal frame",
      woodwht: "White wood frame",
      woodnat: "Natural wood frame",
      wooddark: "Dark wood frame",
      woodblk: "Black wood frame",
    },
    sizes: { sq: "Square", sq40: "Large Square", p34: "Classic", p45: "Standard", p57: "Poster", p70: "X-Large" },
    rotateTitle: "Rotate your phone",
    rotateBody: "Turn your device to landscape to design and preview your map print at its best.",
    alertFail: "Sorry — we couldn't prepare your map for printing just now. Please try again in a moment.",
    variantMissing: "This combination isn’t available right now — please pick a different size or framing.",
    aboutHead: "About this print",
    aboutP: "Turn a place you love into a personalised map print. Whether it's where you met, got married, grew up or honeymooned, our custom map posters let you capture any city, town or street in the world — framed exactly how you like it. Enter a location, choose the precise spot, then pick your size, colour theme, framing and caption to create a one-of-a-kind keepsake. A thoughtful anniversary, wedding, housewarming or birthday gift, each piece is made to order and hand-finished to last.",
    aboutPAerial: "Turn a bird's-eye view of a place you love into a striking aerial photo print. Real satellite imagery captures your home, neighbourhood, coastline or favourite city exactly as it looks from above. Search a location, frame the perfect crop, then choose your size, photo tone, framing and caption to create a one-of-a-kind keepsake. A thoughtful anniversary, wedding, housewarming or birthday gift, each piece is made to order and hand-finished to last.",
    aboutPLanduse: "See a city you love the way planners do — as a vivid mosaic of the neighbourhoods that make it tick. Real OpenStreetMap land-use data paints homes, shops, industry, parks and campuses in bold colour, with the streets carved through in light lines. Search a location, frame the perfect crop, then choose your size, palette, framing and caption to create a one-of-a-kind keepsake. A thoughtful anniversary, wedding, housewarming or birthday gift, each piece is made to order and hand-finished to last.",
    paperHead: "Print on paper",
    paperP: "Available in a range of sizes to suit any space, from a small A4 print to a statement 70 × 100 cm poster. Each personalised map is printed on beautiful high-quality 200 gsm / 65 lb semi-glossy paper that feels silky to the touch, bringing out the rich colours and intricate detail of every street and landmark — a true standout piece in any room.",
    metalHead: "Black metal frame",
    metalP: "Upgrade your custom map poster with a sleek black aluminium frame, approximately 20 mm / 0.8″ thick and 10 mm / 0.4″ wide — the perfect balance of durability and modern style, ready to hang as soon as it arrives.",
    woodHead: "Wood frames",
    woodItems: [
      ["Ready to hang:", "includes hanging kit, ready to hang directly on the wall — no extra framing needed."],
      ["Frame material:", "responsibly sourced, durable pine wood."],
      ["Frame colour:", "white (smooth finish), natural wood, dark brown wood (visible grain) or black — choose the finish that suits your interior."],
      ["Measurements:", "20–25 mm (0.79″–0.98″) thick, 10–14 mm (0.4″–0.6″) wide."],
    ],
    attrib: "Map data © OpenStreetMap contributors, via OpenFreeMap.",
    attribAerial: "Aerial imagery © Esri, Maxar, Earthstar Geographics.",
  };

  var de = {
    eyebrow: "Gestalte deine eigene Karte",
    yourPlace: "Dein Ort",
    mapTitle: function (t) { return "Stadt-Kartenposter"; },
    aerialTitle: function (t) { return t + " Luftbild-Poster"; },
    landuseTitle: function (t) { return t + " Flächennutzungs-Poster"; },
    eyebrowAerial: "Gestalte dein eigenes Luftbild",
    eyebrowLanduse: "Gestalte deine eigene Flächennutzungskarte",
    tabMap: "Kartenposter",
    tabAerial: "Luftbild-Poster",
    tabLanduse: "Flächennutzungs-Poster",
    zoomPre: "Sehr weit hineingezoomt für die Größe",
    zoomPost: "— zoome etwas heraus für gestochen scharfe Details bei diesem großen Format.",
    dragHint: "Ziehen zum Verschieben · Scrollen zum Zoomen",
    recenter: "Zentrieren",
    magnify: "Lupe",
    currency: "€",
    stepLocation: "Dein Ort",
    stepSize: "Größe",
    stepFraming: "Rahmen",
    stepStyle: "Stil",
    stepCaption: "Beschriftung",
    hintCmIn: "cm / in",
    searchPlaceholder: "Ort suchen…",
    exampleLabel: "Beispiel:",
    mapIt: "Suchen",
    errNotFound: "Wir konnten diesen Ort nicht finden — versuche es mit Stadt oder Land.",
    errUnavailable: "Die Suche ist gerade nicht verfügbar. Prüfe deine Verbindung und versuche es erneut.",
    portrait: "Hochformat",
    landscape: "Querformat",
    markers: { pin: "Pin", house: "Haus", heart: "Herz", dot: "Punkt", none: "Ohne" },
    miniMarker: "Markierung",
    miniMarkerSize: "Markierungsgröße",
    miniMarkerColor: "Markierungsfarbe",
    miniLabels: "Beschriftung",
    miniLayout: "Layout", layout1a: "Titelkopf", layout1b: "Galerie",
    miniBorder: "Rand",
    miniDetail: "Kartendetails", detailRich: "Detailliert", detailSimple: "Einfach",
    miniAerial: "Luftbild",
    borderMat: "Breiter Rand",
    borderLine: "Feine Linie",
    borderNone: "Randlos",
    borderCircle: "Kreis",
    borderHeart: "Herz",
    detailRich: "Detailliert",
    detailMinimal: "Minimal",
    fieldTitle: "Titel",
    fieldSubtitle: "Untertitel / Region",
    fieldCoords: "Koordinaten",
    toggleCaption: "Beschriftung anzeigen",
    toggleCoords: "Koordinaten",
    toggleUpper: "Titel in Großbuchstaben",
    addToBasket: "In den Warenkorb",
    preparing: "Dein Druck wird vorbereitet…",
    included: "Inklusive",
    framings: {
      paper: "Druck auf Papier",
      metalblk: "Schwarzer Metallrahmen",
      woodwht: "Weißer Holzrahmen",
      woodnat: "Naturholzrahmen",
      wooddark: "Dunkler Holzrahmen",
      woodblk: "Schwarzer Holzrahmen",
    },
    sizes: { sq: "Quadrat", sq40: "Großes Quadrat", p34: "Klassisch", p45: "Standard", p57: "Poster", p70: "XL" },
    rotateTitle: "Dreh dein Handy",
    rotateBody: "Drehe dein Gerät ins Querformat, um dein Kartenposter optimal zu gestalten und anzusehen.",
    alertFail: "Entschuldigung — wir konnten deine Karte gerade nicht für den Druck vorbereiten. Bitte versuche es gleich noch einmal.",
    variantMissing: "Diese Kombination ist derzeit nicht verfügbar — bitte wähle eine andere Größe oder Rahmung.",
    aboutHead: "Über diesen Druck",
    aboutPAerial: "Verwandle die Vogelperspektive eines Ortes, den du liebst, in ein beeindruckendes Luftbild-Poster. Echte Satellitenaufnahmen zeigen dein Zuhause, dein Viertel, die Küste oder deine Lieblingsstadt genau so, wie sie von oben aussehen. Suche einen Ort, wähle den perfekten Ausschnitt und bestimme Größe, Farbton, Rahmung und Beschriftung — für ein einzigartiges Andenken. Ein durchdachtes Geschenk zu Jahrestag, Hochzeit, Einzug oder Geburtstag; jedes Stück wird auf Bestellung gefertigt.",
    aboutPLanduse: "Sieh eine Stadt, die du liebst, wie ein Stadtplaner — als lebendiges Mosaik ihrer Viertel. Echte OpenStreetMap-Flächennutzungsdaten färben Wohngebiete, Geschäfte, Industrie, Parks und Campus in kräftigen Farben, während die Straßen als helle Linien hindurchlaufen. Suche einen Ort, wähle den perfekten Ausschnitt und bestimme Größe, Farbwelt, Rahmung und Beschriftung — für ein einzigartiges Andenken. Ein durchdachtes Geschenk zu Jahrestag, Hochzeit, Einzug oder Geburtstag; jedes Stück wird auf Bestellung gefertigt.",
    aboutP: "Verwandle einen Ort, den du liebst, in ein persönliches Kartenposter. Ob der Ort, an dem ihr euch kennengelernt oder geheiratet habt, wo du aufgewachsen bist oder eure Flitterwochen wart — mit unseren individuellen Kartenpostern hältst du jede Stadt, jeden Ort und jede Straße der Welt fest, genau so gerahmt, wie du es möchtest. Gib einen Ort ein, wähle die genaue Stelle und bestimme dann Größe, Farbwelt, Rahmen und Beschriftung für ein einzigartiges Andenken. Ein durchdachtes Geschenk zum Jahrestag, zur Hochzeit, zum Einzug oder Geburtstag — jedes Stück wird auf Bestellung gefertigt und von Hand veredelt.",
    paperHead: "Druck auf Papier",
    paperP: "Erhältlich in vielen Größen für jeden Raum — vom kleinen A4-Druck bis zum eindrucksvollen Poster in 70 × 100 cm. Jede personalisierte Karte wird auf hochwertigem, seidigem Semi-Gloss-Papier (200 g/m²) gedruckt, das die satten Farben und feinen Details jeder Straße wunderschön zur Geltung bringt — ein echter Blickfang in jedem Raum.",
    metalHead: "Schwarzer Metallrahmen",
    metalP: "Werte dein Kartenposter mit einem eleganten schwarzen Aluminiumrahmen auf — ca. 20 mm stark und 10 mm breit. Die perfekte Balance aus Langlebigkeit und modernem Stil, sofort bereit zum Aufhängen.",
    woodHead: "Holzrahmen",
    woodItems: [
      ["Fertig zum Aufhängen:", "inklusive Aufhänge-Set — direkt an die Wand, kein zusätzliches Rahmen nötig."],
      ["Rahmenmaterial:", "verantwortungsvoll beschafftes, langlebiges Kiefernholz."],
      ["Rahmenfarbe:", "Weiß (glatte Oberfläche), Naturholz, dunkelbraunes Holz (sichtbare Maserung) oder Schwarz — passend zu deinem Zuhause."],
      ["Maße:", "20–25 mm stark, 10–14 mm breit."],
    ],
    attrib: "Kartendaten © OpenStreetMap-Mitwirkende, über OpenFreeMap.",
    attribAerial: "Luftbildaufnahmen © Esri, Maxar, Earthstar Geographics.",
  };

  var fr = {
    eyebrow: "Créez votre propre carte",
    yourPlace: "Votre lieu",
    mapTitle: function (t) { return "Affiche carte de ville"; },
    aerialTitle: function (t) { return "Photo aérienne " + t; },
    landuseTitle: function (t) { return "Affiche occupation des sols " + t; },
    eyebrowAerial: "Créez votre propre photo aérienne",
    eyebrowLanduse: "Créez votre carte d'occupation des sols",
    tabMap: "Affiche carte",
    tabAerial: "Photo aérienne",
    tabLanduse: "Occupation des sols",
    zoomPre: "Zoom très rapproché pour le format",
    zoomPost: "— dézoomez légèrement pour un rendu parfaitement net sur un tirage de cette taille.",
    dragHint: "Faites glisser pour repositionner · molette pour zoomer",
    recenter: "Recentrer",
    magnify: "Loupe",
    currency: "€",
    stepLocation: "Votre lieu",
    stepSize: "Format",
    stepFraming: "Encadrement",
    stepStyle: "Style",
    stepCaption: "Légende",
    hintCmIn: "cm / in",
    searchPlaceholder: "Rechercher un lieu…",
    exampleLabel: "exemple :",
    mapIt: "Localiser",
    errNotFound: "Nous n'avons pas trouvé ce lieu — essayez d'ajouter une ville ou un pays.",
    errUnavailable: "La recherche est momentanément indisponible. Vérifiez votre connexion et réessayez.",
    portrait: "Portrait",
    landscape: "Paysage",
    markers: { pin: "Épingle", house: "Maison", heart: "Cœur", dot: "Point", none: "Aucun" },
    miniMarker: "Repère",
    miniMarkerSize: "Taille du repère",
    miniMarkerColor: "Couleur du repère",
    miniLabels: "Libellés",
    miniLayout: "Mise en page", layout1a: "Bandeau", layout1b: "Galerie",
    miniBorder: "Bordure",
    miniDetail: "Détail de la carte", detailRich: "Détaillé", detailSimple: "Simple",
    miniAerial: "Photo aérienne",
    borderMat: "Marge large",
    borderLine: "Filet fin",
    borderNone: "Sans bordure",
    borderCircle: "Cercle",
    borderHeart: "Cœur",
    detailRich: "Détaillée",
    detailMinimal: "Minimale",
    fieldTitle: "Titre",
    fieldSubtitle: "Sous-titre / région",
    fieldCoords: "Coordonnées",
    toggleCaption: "Afficher la légende",
    toggleCoords: "Coordonnées",
    toggleUpper: "Titre en majuscules",
    addToBasket: "Ajouter au panier",
    preparing: "Préparation de votre tirage…",
    included: "Inclus",
    framings: {
      paper: "Tirage papier",
      metalblk: "Cadre métal noir",
      woodwht: "Cadre bois blanc",
      woodnat: "Cadre bois naturel",
      wooddark: "Cadre bois foncé",
      woodblk: "Cadre bois noir",
    },
    sizes: { sq: "Carré", sq40: "Grand carré", p34: "Classique", p45: "Standard", p57: "Poster", p70: "Très grand" },
    rotateTitle: "Tournez votre téléphone",
    rotateBody: "Tournez votre appareil en mode paysage pour créer et prévisualiser votre affiche dans les meilleures conditions.",
    alertFail: "Désolé — nous n'avons pas pu préparer votre carte pour l'impression. Veuillez réessayer dans un instant.",
    variantMissing: "Cette combinaison n’est pas disponible pour le moment — choisissez un autre format ou encadrement.",
    aboutHead: "À propos de ce tirage",
    aboutPAerial: "Transformez la vue du ciel d'un lieu qui vous est cher en un superbe tirage photo aérien. De véritables images satellite capturent votre maison, votre quartier, votre littoral ou votre ville préférée exactement tels qu'ils apparaissent vus d'en haut. Recherchez un lieu, cadrez la vue parfaite, puis choisissez le format, le ton photo, l'encadrement et la légende pour créer un souvenir unique. Un cadeau idéal pour un anniversaire, un mariage ou une crémaillère — chaque pièce est fabriquée à la commande.",
    aboutPLanduse: "Découvrez une ville que vous aimez comme la voient les urbanistes — une mosaïque vivante de ses quartiers. De vraies données d'occupation des sols OpenStreetMap colorent habitations, commerces, industrie, parcs et campus en teintes franches, les rues se dessinant en lignes claires. Recherchez un lieu, cadrez la vue parfaite, puis choisissez le format, la palette, l'encadrement et la légende pour créer un souvenir unique. Un cadeau idéal pour un anniversaire, un mariage ou une crémaillère — chaque pièce est fabriquée à la commande.",
    aboutP: "Transformez un lieu qui vous est cher en une affiche personnalisée. L'endroit où vous vous êtes rencontrés, mariés, où vous avez grandi ou passé votre lune de miel — nos affiches cartographiques sur mesure capturent n'importe quelle ville, village ou rue du monde, encadrée exactement comme vous le souhaitez. Saisissez un lieu, choisissez l'endroit précis, puis sélectionnez le format, les couleurs, l'encadrement et la légende pour créer un souvenir unique. Un cadeau idéal pour un anniversaire, un mariage ou une crémaillère — chaque pièce est fabriquée à la commande et finie à la main.",
    paperHead: "Tirage papier",
    paperP: "Disponible dans une gamme de formats adaptés à tous les espaces, du petit tirage A4 à l'affiche spectaculaire de 70 × 100 cm. Chaque carte personnalisée est imprimée sur un beau papier semi-brillant de 200 g/m², doux au toucher, qui révèle les couleurs riches et les détails minutieux de chaque rue — une pièce qui attire tous les regards.",
    metalHead: "Cadre métal noir",
    metalP: "Sublimez votre affiche avec un élégant cadre en aluminium noir, d'environ 20 mm d'épaisseur et 10 mm de largeur — l'équilibre parfait entre durabilité et style moderne, prêt à accrocher dès réception.",
    woodHead: "Cadres bois",
    woodItems: [
      ["Prêt à accrocher :", "kit de fixation inclus, à suspendre directement au mur — aucun encadrement supplémentaire nécessaire."],
      ["Matériau :", "pin durable issu de sources responsables."],
      ["Couleur du cadre :", "blanc (finition lisse), bois naturel, bois brun foncé (veinage apparent) ou noir — selon votre intérieur."],
      ["Dimensions :", "20–25 mm d'épaisseur, 10–14 mm de largeur."],
    ],
    attrib: "Données cartographiques © contributeurs OpenStreetMap, via OpenFreeMap.",
    attribAerial: "Imagerie aérienne © Esri, Maxar, Earthstar Geographics.",
  };

  var es = {
    eyebrow: "Crea tu propio mapa",
    yourPlace: "Tu lugar",
    mapTitle: function (t) { return "Lámina mapa de ciudad"; },
    aerialTitle: function (t) { return "Lámina aérea " + t; },
    landuseTitle: function (t) { return "Lámina usos del suelo " + t; },
    eyebrowAerial: "Crea tu propia foto aérea",
    eyebrowLanduse: "Crea tu propio mapa de usos del suelo",
    tabMap: "Lámina de mapa",
    tabAerial: "Foto aérea",
    tabLanduse: "Usos del suelo",
    zoomPre: "Has acercado mucho el mapa para el tamaño",
    zoomPost: "— aléjate un poco para obtener el máximo detalle en una impresión tan grande.",
    dragHint: "Arrastra para reposicionar · desplázate para hacer zoom",
    recenter: "Centrar",
    magnify: "Lupa",
    currency: "€",
    stepLocation: "Tu ubicación",
    stepSize: "Tamaño",
    stepFraming: "Enmarcado",
    stepStyle: "Estilo",
    stepCaption: "Texto",
    hintCmIn: "cm / in",
    searchPlaceholder: "Buscar un lugar…",
    exampleLabel: "ejemplo:",
    mapIt: "Buscar",
    errNotFound: "No encontramos ese lugar: prueba añadiendo la ciudad o el país.",
    errUnavailable: "La búsqueda no está disponible ahora mismo. Comprueba tu conexión e inténtalo de nuevo.",
    portrait: "Vertical",
    landscape: "Horizontal",
    markers: { pin: "Pin", house: "Casa", heart: "Corazón", dot: "Punto", none: "Ninguno" },
    miniMarker: "Marcador",
    miniMarkerSize: "Tamaño del marcador",
    miniMarkerColor: "Color del marcador",
    miniLabels: "Etiquetas",
    miniLayout: "Diseño", layout1a: "Cabecera", layout1b: "Galería",
    miniBorder: "Borde",
    miniDetail: "Detalle del mapa", detailRich: "Detallado", detailSimple: "Simple",
    miniAerial: "Foto aérea",
    borderMat: "Margen ancho",
    borderLine: "Línea fina",
    borderNone: "Sin borde",
    borderCircle: "Círculo",
    borderHeart: "Corazón",
    detailRich: "Detallado",
    detailMinimal: "Minimalista",
    fieldTitle: "Título",
    fieldSubtitle: "Subtítulo / región",
    fieldCoords: "Coordenadas",
    toggleCaption: "Mostrar texto",
    toggleCoords: "Coordenadas",
    toggleUpper: "Título en mayúsculas",
    addToBasket: "Añadir a la cesta",
    preparing: "Preparando tu impresión…",
    included: "Incluido",
    framings: {
      paper: "Impresión en papel",
      metalblk: "Marco metálico negro",
      woodwht: "Marco de madera blanco",
      woodnat: "Marco de madera natural",
      wooddark: "Marco de madera oscura",
      woodblk: "Marco de madera negro",
    },
    sizes: { sq: "Cuadrado", sq40: "Cuadrado grande", p34: "Clásico", p45: "Estándar", p57: "Póster", p70: "XL" },
    rotateTitle: "Gira tu teléfono",
    rotateBody: "Gira tu dispositivo en horizontal para diseñar y previsualizar tu lámina al máximo detalle.",
    alertFail: "Lo sentimos: no hemos podido preparar tu mapa para imprimir. Inténtalo de nuevo en un momento.",
    variantMissing: "Esta combinación no está disponible ahora mismo: elige otro tamaño o enmarcado.",
    aboutHead: "Sobre esta lámina",
    aboutPAerial: "Convierte la vista aérea de un lugar especial en una impresionante lámina fotográfica. Imágenes reales de satélite capturan tu casa, tu barrio, la costa o tu ciudad favorita tal y como se ven desde el cielo. Busca un lugar, encuadra la vista perfecta y elige tamaño, tono fotográfico, enmarcado y leyenda para crear un recuerdo único. Un regalo perfecto de aniversario, boda, estreno de casa o cumpleaños; cada pieza se fabrica bajo pedido.",
    aboutPLanduse: "Mira una ciudad que amas como la ven los urbanistas: un mosaico vivo de sus barrios. Datos reales de usos del suelo de OpenStreetMap pintan viviendas, comercios, industria, parques y campus en colores intensos, con las calles trazadas en líneas claras. Busca un lugar, encuadra la vista perfecta y elige tamaño, paleta, enmarcado y leyenda para crear un recuerdo único. Un regalo perfecto de aniversario, boda, estreno de casa o cumpleaños; cada pieza se fabrica bajo pedido.",
    aboutP: "Convierte un lugar especial en una lámina de mapa personalizada. El sitio donde os conocisteis, os casasteis, creciste o pasasteis la luna de miel: nuestros pósteres de mapas personalizados capturan cualquier ciudad, pueblo o calle del mundo, enmarcados exactamente a tu gusto. Escribe una ubicación, elige el punto exacto y selecciona el tamaño, los colores, el marco y el texto para crear un recuerdo único. Un regalo perfecto de aniversario, boda, inauguración o cumpleaños: cada pieza se hace por encargo y se acaba a mano.",
    paperHead: "Impresión en papel",
    paperP: "Disponible en una gran variedad de tamaños, desde una lámina A4 hasta un póster espectacular de 70 × 100 cm. Cada mapa personalizado se imprime en papel semibrillante de alta calidad de 200 g/m², suave al tacto, que realza los colores intensos y el detalle minucioso de cada calle — una pieza que destaca en cualquier estancia.",
    metalHead: "Marco metálico negro",
    metalP: "Mejora tu póster con un elegante marco de aluminio negro, de unos 20 mm de grosor y 10 mm de ancho: el equilibrio perfecto entre durabilidad y estilo moderno, listo para colgar nada más llegar.",
    woodHead: "Marcos de madera",
    woodItems: [
      ["Listo para colgar:", "incluye kit de colgado, listo para la pared — sin necesidad de enmarcar."],
      ["Material del marco:", "madera de pino duradera y de origen responsable."],
      ["Color del marco:", "blanco (acabado liso), madera natural, madera marrón oscuro (veta visible) o negro."],
      ["Medidas:", "20–25 mm de grosor, 10–14 mm de ancho."],
    ],
    attrib: "Datos del mapa © colaboradores de OpenStreetMap, vía OpenFreeMap.",
    attribAerial: "Imágenes aéreas © Esri, Maxar, Earthstar Geographics.",
  };

  var LOCALES = { en: en, de: de, fr: fr, es: es };

  window.SOUVENIR_I18N = {
    locales: LOCALES,
    // pick("de") / pick("fr-CA") / pick("es") → full dictionary, EN fallback per key
    pick: function (code) {
      var k = String(code || "en").slice(0, 2).toLowerCase();
      var o = LOCALES[k] || {};
      var m = {};
      for (var key in en) m[key] = o[key] != null ? o[key] : en[key];
      return m;
    },
  };
})();
